
let language = {
    PREVIEW_MODAL_IMAGE_TYPE_TITLE: "Image/",
    PREVIEW_MODAL_EDIT_FILE_NAME_TITLE: "编辑文件名称",
    
    // 
    PREVIEW_MODAL_DOWNLOAD_BTN: "下载",
    PREVIEW_MODAL_VIEW_SIZE_BTN: "浏览全图",
    PREVIEW_MODAL_DELETE_BTN: "删除",
    PREVIEW_MODAL_CANCEL_BTN: "取消",
    PREVIEW_MODAL_SAVE_BTN: "确认",
    
    // 
    PREVIEW_MODAL_FILE_NAME_CAN_NOT_EMPTY_TIP: "文件名不能为空!",
    PREVIEW_MODAL_FILE_NAME_DUPLICATE_TIP: "文件名重复!",
    PREVIEW_MODAL_FILE_NAME_PATTERN_TIP: "文件名不能包含以下字符: \\ \/ \: \* \? \" \< \> \|",
    
    PREVIEW_MODAL_DELETE_ITEM_ALERT_TITLE: "删除文件",
    PREVIEW_MODAL_DELETE_ITEM_ALERT_CONTENT: "您确定要删除所选文件吗?",
};

export { language }